import styled from 'styled-components'

export const Wrap = styled.section`
  margin-top: 45px;
  position: relative;
  @media(max-width: 575px) {
    padding: 0 15px;
  }
`
export const List = styled.ul`
  position: relative;
  z-index: 2;
`

export const BgDecor = styled.img.attrs({ src: '/decor/trimmer.png', role: 'presentation' })`
  position: absolute;
  z-index: 0;
  left: 0;
  top: 40%;
  left: -26%;
  @media(max-width: 1300px) {
    top: -20%;
  }
  @media(max-width: 600px) {
    display: none;
  }
`;
export const PaginateWrap = styled.div`
  position: relative;
  z-index: 2;
  margin-top: 30px;
  display: flex;
  justify-content: center;
`;
